var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.4A9.96 9.96 0 0112 2c4.832 0 8.864 3.428 9.797 7.985a10.045 10.045 0 01-.18 4.767A10.005 10.005 0 0118.5 19.6 9.961 9.961 0 0112 22C6.477 22 2 17.523 2 12a9.97 9.97 0 013.5-7.6zm5.75 8.35v7.717a8.462 8.462 0 01-4.683-1.93 9.958 9.958 0 002.405-5.787h2.278zm-3.782 0A8.457 8.457 0 015.5 17.478a8.463 8.463 0 01-1.967-4.728h3.935zm1.504-1.5h2.278V3.533a8.462 8.462 0 00-4.683 1.93 9.957 9.957 0 012.405 5.787zM5.5 6.522a8.457 8.457 0 011.968 4.728H3.533l.01-.114A8.463 8.463 0 015.5 6.522zm7.25 6.228v7.717a8.462 8.462 0 004.683-1.93 9.958 9.958 0 01-2.405-5.787H12.75zm2.278-1.5a9.957 9.957 0 012.405-5.788 8.462 8.462 0 00-4.683-1.93v7.718h2.278zM18.5 6.522a8.457 8.457 0 00-1.968 4.728h3.935A8.462 8.462 0 0018.5 6.522zm1.967 6.228h-3.934a8.458 8.458 0 001.967 4.728 8.463 8.463 0 001.967-4.728z",
    fill: "currentColor"
  })));
}
SvgSport.displayName = 'Sport';
export default SvgSport;